module.exports = __webpack_public_path__ + "img/artilleryRight.cf52ef17.svg";